import HundredBricksAPIError from '../../../HundredBricksAPIError';
class OnSaleStatusReportError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('OnSaleStatusReportError', ...args);
    }
}
export default OnSaleStatusReportError;
